import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { getEvaluableStart, getQuiz } from 'store/lesson-actions';
import { getUserAditionalTrackCourse } from 'store/course-actions';

import Feedback from './Questions/Feedback/Feedback';
import Loading from 'components/UI/Loading/Loading';
import Questions from './Questions/Questions';
import QuizInstructions from './QuizInstructions/QuizInstructions';

let loadQuizData = false;

const QuizContainer = props => {
  const dispatch = useDispatch();
  const [questionsView, setQuestionsView] = useState(false);
  const [feedbackView, setFeedbackView] = useState(false);
  const [feedbackData, setFeedbackData] = useState('');
  const [calificationData, setCalificationData] = useState('');
  const [evaluate, setEvaluate] = useState(0);
  const [loading, seLoading] = useState(true);
  const dataLesson = useSelector(state => state.lessonInfo);
  const dataAcademy = useSelector(state => state.academyInfo);

  useEffect(() => {
    dispatch(
      getQuiz(dataLesson.data.idQuiz, 0, dataAcademy.data.shortName)
    );
    dispatch(
      getEvaluableStart(
        dataLesson.data.idQuiz,
        props.idCourse,
        0,
        dataAcademy.data.shortName
      )
    );
  }, [dataLesson.data.idQuiz, dataAcademy.data]);

  useEffect(() => {
    if (
      dataLesson.quizEvaluableData &&
      dataLesson.quizEvaluableData.idApplication > 0 &&
      dataLesson.data &&
      !loadQuizData
    ) {
      dispatch(
        getQuiz(
          dataLesson.data.idQuiz,
          dataLesson.quizEvaluableData.idApplication,
          dataAcademy.data.shortName
        )
      );
      dispatch(
        getEvaluableStart(
          dataLesson.data.idQuiz,
          props.idCourse,
          dataLesson.quizEvaluableData.idApplication,
          dataAcademy.data.shortName
        )
      );
      loadQuizData = true;
    }
  }, [dataLesson.quizEvaluableData, dataLesson.data]);

  useEffect(() => {
    if (dataLesson.quizData && dataLesson.quizEvaluableData) {
      seLoading(false);
    }
  }, [dataLesson]);

  const changeViewHandler = () => {
    setQuestionsView(!questionsView);
    setFeedbackView(false);
  };

  const showFeedbackHandler = (
    feedbackData,
    calification,
    evaluate
  ) => {
    setEvaluate(evaluate);
    setFeedbackData(feedbackData);
    setCalificationData(calification);
    setFeedbackView(true);
    dispatch(getUserAditionalTrackCourse(props.idCourse));
  };

  return (
    <>
      {!feedbackView ? (
        <>
          {!loading && (
            <>
              {!questionsView ? (
                <QuizInstructions
                  description={dataLesson.quizData.description}
                  preCalifications={
                    dataLesson.quizEvaluableData.appsPrev
                  }
                  changeView={changeViewHandler}
                />
              ) : (
                <Questions
                  idQuiz={dataLesson.quizData.idQuiz}
                  idApplication={
                    dataLesson.quizEvaluableData.idApplication
                  }
                  changeView={changeViewHandler}
                  questions={dataLesson.quizData.questions}
                  showFeedback={showFeedbackHandler}
                  changeQuizStatus={props.changeQuizStatus}
                />
              )}
            </>
          )}
          {loading && <Loading />}
        </>
      ) : (
        <Feedback
          feedbackData={feedbackData}
          calificationData={calificationData}
          evaluate={evaluate}
          changeView={changeViewHandler}
          returnVideo={props.returnVideo}
        />
      )}
    </>
  );
};

QuizContainer.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  changeQuizStatus: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  returnVideo: PropTypes.func
};

export default QuizContainer;
